export default (value, amount) => {
  return `${value}${amount !== 1 ? 's' : ''}`
}
